export default "__VITE_ASSET__DGzvHcrF__"